import React from 'react';
import { Center, Divider } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { translate } from '../../utils/translate';

export const OrDivider = () => (
    <Center direction="row" gap="3">
        <Divider />
        <Typography color="grey_700" size="b_xs" fontWeight="bold">
            {translate('social.or')}
        </Typography>
        <Divider />
    </Center>
);
